import type { ExperimentalMutations } from '../__types__/ExperimentalMutations'; //eslint-disable-line no-restricted-imports
import { fetchJSON } from '../fetchJSON';

export const experimentalCreateAutomationRuleFromTemplate: ExperimentalMutations['experimentalCreateAutomationRuleFromTemplate'] =
	(_, { templateId, cloudId, automationStack, spaceId, parameters }, { network }) => {
		const ruleHome = spaceId
			? `ari:cloud:confluence:${cloudId}:space/${spaceId}`
			: `ari:cloud:confluence::site/${cloudId}`;

		let formattedParameters: {
			[name: string]: {
				value: string;
				type: string;
			};
		} | null = null;
		if (parameters) {
			formattedParameters = {};
			for (const parameter of parameters) {
				formattedParameters[parameter.name] = {
					value: parameter.value,
					type: parameter.type,
				};
			}
		}

		return fetchJSON(
			network,
			`/gateway/api/automation/internal-api/confluence/${cloudId}/${automationStack}/public/rest/v1/template/create`,
			{
				method: 'POST',
				credentials: 'include',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					templateId,
					ruleHome,
					parameters: formattedParameters,
				}),
			},
		).then((response) => {
			return {
				ruleId: response.ruleId,
				ruleUuid: response.ruleUuid,
			};
		});
	};
